import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography, useTheme } from "@mui/material";
import ExtensionIcon from "@mui/icons-material/Extension";
import { Trans } from "@lingui/react/macro";
import type { RootState } from "../../store/types.tsx";
import { useFeatureFlag } from "../../hooks/useFeatureFlag.tsx";
import SelectLLMModel from "./SelectLLMModel.tsx";
import GoogleSheetDrawerAction from "./GoogleSheetDrawerAction.tsx";
import MemoryDrawerAction from "./MemoryDrawerAction.tsx";
import NotificationsDrawerAction from "../notifications/NotificationsDrawerAction.tsx";

interface ConversationDrawerActionsProps {
  closeDrawer: () => void;
  onShowIntegrations?: () => void;
}

const ConversationDrawerActions: React.FC<ConversationDrawerActionsProps> = ({
  closeDrawer,
  onShowIntegrations,
}) => {
  const theme = useTheme();
  const availableModels = useSelector(
    (state: RootState) => state.conversationState.availableModels,
  );
  const hasIntegrationsPage = useFeatureFlag("integrations_page");

  const handleIntegrationsClick = () => {
    closeDrawer();
    onShowIntegrations?.();
  };
  return (
    <Box
      marginBottom={2}
      sx={{
        py: "4px",
        backgroundColor: "inherit",
        flexShrink: 0,
      }}
    >
      <NotificationsDrawerAction closeDrawer={closeDrawer} />

      <MemoryDrawerAction closeDrawer={closeDrawer} />

      <GoogleSheetDrawerAction closeDrawer={closeDrawer} />

      {hasIntegrationsPage && (
        <Typography
          variant="h4"
          onClick={handleIntegrationsClick}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            cursor: "pointer",
            whiteSpace: "nowrap",
            fontSize: "1rem !important",
            width: "100%",
            lineHeight: "1",
            margin: "0",
            py: "6px",
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
              borderRadius: "25px",
            },
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "20px",
              height: "20px",
            }}
          >
            <ExtensionIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "left",
            }}
          >
            <Trans context="Drawer action label for integrations page">
              Integrations
            </Trans>
          </Box>
        </Typography>
      )}

      {availableModels && availableModels.length > 0 && (
        <SelectLLMModel availableModels={availableModels} />
      )}
    </Box>
  );
};

export default ConversationDrawerActions;
